import { all, call, fork, put, select, take } from 'redux-saga/effects';

import { DELETE_HIGHLIGHT } from './actions';
import { RESET_ANNOTATION } from 'Reducers/compModels';
import { SAVE_HIGHLIGHTS, SAVE_NOTES } from 'Reducers/dataModels';

import notebookFilterMarkers from 'Lib/notebookFilterMarkers';
import { deleteHighlight as vsDeleteHighlight } from 'Services/learnkit';


function* delete_() {
  while (true) {
    const { data:selHighlightId } = yield take(DELETE_HIGHLIGHT);
    const { highlights, notes } = yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });

    const { code, message } = yield call(vsDeleteHighlight, selHighlightId);

    //filter the deleted highlight
    const updatedHighlights = highlights.filter(highlight => {
      return highlight.id !== selHighlightId;
    });

    yield fork(notebookFilterMarkers, updatedHighlights);

    const updatedNotes = notes.filter(note => {
      return note.id !== selHighlightId;
    });

    yield all([
      put({ type: RESET_ANNOTATION }),
      put({ type: SAVE_HIGHLIGHTS, data: updatedHighlights }),
      put({ type: SAVE_NOTES, data: updatedNotes })
    ]);
  }
}


export default delete_;
